<div class="container-capped px-2 white-bg my-3 relative">
	<ng-container *ngIf="rtwad">
		<div class="d-flex justify-content-between">
			<i class="fa fa-arrow-right f-blue fs-xl py-2 pl-4 pr-1 pointer" (click)="back()"></i>
			<div title="به اشتراک‌گذاری" class="btn btn-secondary btn-icon-circle mr-2" (click)="share()"
				ga-event="share|rtwad-detail">
				<i class="fa fa-share-alt fs-lg"></i>
			</div>
		</div>
		<app-breadcrumb [breadcrumb-data]="breadcrumbData" [hide-last]="0" *ngIf="breadcrumbData">
		</app-breadcrumb>

		<div class="px-2">
			<h1 class="h4 mb-2 wrap">{{rtwad.Title}}</h1>
		</div>
		<div class="px-2 mb-3">
			<h6 *ngIf="rtwad.ContactName">{{rtwad.ContactName}}</h6>
		</div>
		<div *ngIf="rtwad.Code" class="px-2 fs-sm f-gray fsp-1" [copy]="rtwad.Code">
			کد آگهی: KP{{rtwad.Code}}
		</div>
		<div class="d-flex flex-column flex-md-row gap-2">
			<div class="flex-grow-1 leaf-pre-line order-1 order-md-0 px-2">
				<h5 class="fw-bold d-flex"><i class="fa fa-align-right ml-2 fs-xl"></i><span>متن کامل آگهی:</span>
				</h5>
				<div class="text-justify fs-lg long-text wrap  my-2  p-2 overflow-auto"
					[innerHTML]="(rtwad.Description || rtwad.Title)" [attr.dir]="rtwad.IsLtr ? 'ltr' : undefined">
				</div>
			</div>
			<div *ngIf="rtwad.Images?.length" class="w-md-50 order-0 order-md-1">
				<div id="carouselIndicators" class="carousel slide" data-ride="carousel">
					<ol class="carousel-indicators">
						<li data-target="#carouselIndicators" *ngFor="let img of rtwad.Images;let i=index" [attr.data-slide-to]="i"
							[class.active]="i==0"></li>
					</ol>
					<div class="carousel-inner">
						<div class="carousel-item" *ngFor="let img of rtwad.Images;let i=index" [class.active]="i==0">
							<img class="cover rounded w-100" [src]="img.startsWith('http') ? img : imagePath + img + '?size=500'"
								style="aspect-ratio: 1/1" [alt]="rtwad.Title">
						</div>
					</div>
					<a *ngIf="rtwad.Images?.length > 1" class="carousel-control-prev" data-target="#carouselIndicators"
						role="button" data-slide="prev">
						<span class="carousel-control-prev-icon" aria-hidden="true"></span>
						<span class="sr-only">قبلی</span>
					</a>
					<a *ngIf="rtwad.Images?.length > 1" class="carousel-control-next" data-target="#carouselIndicators"
						role="button" data-slide="next">
						<span class="carousel-control-next-icon" aria-hidden="true"></span>
						<span class="sr-only">بعدی</span>
					</a>
				</div>

			</div>

		</div>
		<div class="d-flex flex-wrap align-items-center px-2">
			<div *ngFor="let tag of rtwad.Tags" class="badge p-1 x-light-gray-bg fs-sm ml-1 mb-1">
				{{tag}}</div>
		</div>

		<div class="p-2 white-bg sticky-bottom mt-5">
			<div class="container-capped-xs px-0">
				<button type="button" class="btn btn-primary w-100" *ngIf="rtwad.IsIndexed"
					(click)="redirectModal.open()">دریافت اطلاعات
					تماس</button>
				<button type="button" class="btn btn-primary w-100" *ngIf="!rtwad.IsIndexed"
					(click)="loadContactInfo();showContactModal.open()">دریافت اطلاعات
					تماس</button>
			</div>

		</div>

		<ngx-smart-modal #showContactModal identifier="showContactModal" customClass="">
			<div class="d-flex flex-column gap-2 py-2 container-capped-sm container-min-xs p-3 kp-spinner-container-lg">
				<div [ngClass]="{'d-none': currentUser}">
					<div> برای دریافت اطلاعات تماس در کارپیشه ثبت‌نام کن.</div>
					<app-login [inline]="true" [flat]="true" [heading]="''" [intro]="''" registerType="Rtwad"
						(login)="loadContactInfo();">
					</app-login>

				</div>
				<ng-container *ngIf="currentUser">
					<ngx-spinner name="rtwad-contacts" [fullScreen]="false" type="timer"></ngx-spinner>

					<div *ngIf="rtwad.ContactName">
						<h6>نام</h6>
						<a href="tel://{{rtwad.ContactName}}">{{rtwad.ContactName}}</a>
					</div>
					<div *ngIf="rtwad.Phone">
						<h6>شماره تلفن</h6>
						<a class="text-left" dir="ltr" href="tel://{{rtwad.Phone}}">{{rtwad.Phone}}</a>
					</div>
					<div *ngIf="rtwad.Email">
						<h6>ایمیل</h6>
						<a class="text-left" dir="ltr" href="mailto://{{rtwad.Email}}">{{rtwad.Email}}</a>
					</div>
					<div class="border border-dark rounded-xl fs-sm lh-sm p-2 text-justify">
						<div class="d-flex align-items-center f-red"><i class="fa fa-exclamation-triangle ml-2 fs-lg"></i>
							<div class="fw-bold fs-lg">هشدار</div>
						</div> کارپیشه صرفا منتشر کننده آگهی بوده و هیچ گونه مسئولیتی در قبال آگهی دهنده و صحت متن آگهی ندارد.
					</div>
				</ng-container>

			</div>
		</ngx-smart-modal>
		<ngx-smart-modal #redirectModal identifier="redirectModal" customClass="full-width">
			<div class="container-capped-sm p-3" *ngIf="redirectModal.visible">
				<div class="text-center pb-2">
					<img class="icon-sm ml-1" *ngIf="rtwad.Source?.Url" [alt]="rtwad.Source.Title"
						[src]="rtwad.Source.Url|favicon" />
					<i class="fa fa-exchange-alt fs-xxl m-2 fw-bold f-x-dark-blue"></i>
				</div>
				<div class="text-justify">
					این آگهی
					در <span class="fw-bold">{{rtwad.Source?.Title}}</span>
					ثبت شده.<br />
					شما رو به اون سایت می‌فرستیم تا از اون‌جا اطلاعات تماس آگهی‌دهنده رو دریافت کنی.<br />
					نگران نباش! اگر در {{rtwad.Source?.Title}} متوجه شدی که این آگهی مناسب نیست، با زدن دکمه‌ی
					<span class="fw-extrabold"> بازگشت </span>
					به جستجوی خودت در کارپیشه برمی‌گردی.
				</div>
				<div class="border-gray border-top py-2 my-2" *ngIf="!currentUser">
					<div> قبل از رفتن در کارپیشه ثبت‌نام کن.</div>
					<app-login [inline]="true" [flat]="true" [heading]="''" [intro]="''" registerType="Rtwad"
						(auth)="hideSourceLink=true">
					</app-login>
					<div class="py-2" *ngIf="!hideSourceLink">
						<a class="btn btn-link f-blue w-100" title="تماس با کارفرما" (click)="replaceState(rtwad.Source.Url)"
							[href]="rtwad.Source.Url">بدون ثبت‌نام آگهی رو در {{rtwad.Source.Title}} ببین</a>
					</div>
				</div>
				<div class="border-gray border-top py-2 my-2" *ngIf="currentUser">
					<label class="mx-1 mb-0 d-flex align-items-center">
						<input type="checkbox" name="auto-redirect" [(ngModel)]="autoRedirect" />
						<span> برای آگهی‌های بعدی این صفحه رو نشونم نده</span>
					</label>
					<div class="py-2">
						<a class="btn btn-secondary w-100 f-dark-blue" title="تماس با کارفرما"
							(click)="replaceState(rtwad.Source.Url)" [href]="rtwad.Source.Url">
							<img class="icon-sm ml-1" *ngIf="rtwad.Source?.Url" [alt]="rtwad.Source.Title"
								[src]="rtwad.Source.Url|favicon" />
							آگهی رو در {{rtwad.Source.Title}} ببین</a>
					</div>
				</div>
			</div>
		</ngx-smart-modal>

	</ng-container>
</div>